const reportToInsight = function (predicate, object, subjectMeta) {

    if(!window.decClientReady){
        return;
    }

    const client = window.DataIntelligenceSubmitScript._client.sentenceClient

    subjectMeta['Email'] = client.subjectKey + '@temp.kmc.co.uk'

    client.writeSentence({
        predicate: predicate,
        object: object,
        subjectMetadata: subjectMeta
    });
}

export {
    reportToInsight
}
